export default __webpack_public_path__ + "static/media/portadavideoplanificacion6.18e8b0a4.png";